<script setup>
import IconArrowUpRight from "@components/icons/ArrowUpRight.vue";

import { useGlobalStore } from "@stores/global";
import { useGlobeStore } from "@stores/globe";
import { useExpediaStore } from "@stores/expedia";

const globalStore = useGlobalStore();
const globeStore = useGlobeStore();
const expediaStore = useExpediaStore();
const GET_STARTED_PAGES = ["explore", "achievements", "settings"];
</script>

<template>
    <Transition name="fade" appear>
        <div
            v-if="
                globalStore.panelActive('getStarted') &&
                !globeStore.selectedCountry &&
                GET_STARTED_PAGES.includes(globalStore.activePage)
            "
            class="get-started bg-marine-800 border-marine-500 relative isolate flex flex-col justify-between border-r p-6"
        >
            <div
                class="border-marine-500 flex flex-col gap-2.5 lg:gap-8 lg:border-b lg:pb-7.5"
            >
                <p class="h5 leading-[0.9] font-bold uppercase">
                    Go places
                    <br />
                    <span class="font-extrabold text-yellow-400">
                        like ishowspeed
                    </span>
                </p>
                <p class="body-sm leading-none">
                    <a
                        :href="expediaStore.href('')"
                        target="_blank"
                        class="text-white underline"
                        >Book a trip today</a
                    >
                    to win a chance to meet Speed. Follow
                    <span class="text-yellow-400 underline">@Expedia</span>

                    on
                    <a
                        href="https://www.instagram.com/expedia/"
                        target="_blank"
                        class="underline"
                        >Instagram</a
                    >
                    and

                    <a
                        href="https://www.tiktok.com/@expedia"
                        target="_blank"
                        class="underline"
                        >TikTok</a
                    >
                    for updates.
                </p>
            </div>
            <div
                class="body-xs flex w-full flex-col gap-2 leading-tight lg:gap-3"
            >
                <p>
                    &copy; {{ new Date().getFullYear() }} Expedia Group &amp;
                    iShowSpeed. All rights reserved.
                </p>
                <div class="flex flex-wrap gap-3">
                    <router-link
                        :to="{ name: 'about' }"
                        class="faded-text uppercase underline transition-opacity hover:opacity-100"
                    >
                        About
                    </router-link>
                    <a
                        href="https://www.expedia.com/lp/b/terms-of-service"
                        target="_blank"
                        class="faded-text uppercase underline transition-opacity hover:opacity-100"
                    >
                        Terms and Conditions
                    </a>
                    <a
                        href="https://www.expedia.com/legal/privacy"
                        target="_blank"
                        class="faded-text uppercase underline transition-opacity hover:opacity-100"
                    >
                        Privacy Policy
                    </a>
                    <button
                        id="ot-sdk-btn"
                        class="ot-sdk-show-settings faded-text uppercase underline transition-opacity hover:opacity-100"
                    >
                        Cookie Settings
                    </button>
                    <a
                        href="mailto:ishowspeed@expediagroup.com"
                        class="faded-text uppercase underline transition-opacity hover:opacity-100"
                    >
                        Contact Us
                    </a>
                </div>
            </div>
            <IconArrowUpRight
                class="absolute top-4 right-4 h-5 text-yellow-400"
            />
        </div>
    </Transition>
</template>

<style scoped>
.get-started {
    grid-column: 1 / 7;
    grid-row: -5 / -1;
    z-index: 2;
}

:deep(#ot-sdk-btn.ot-sdk-show-settings) {
    background: transparent;
    color: inherit;
    height: auto;
    white-space: inherit;
    word-wrap: inherit;
    padding: 0;
    font-size: inherit;
    line-height: inherit;
}

@media (max-width: 1024px) {
    .get-started {
        grid-column: 1 / -1;
    }
}
</style>
